/*
  Copyright 2019 Bit Factory, Inc.
  This Source Code Form is subject to the terms of the Mozilla Public
  License, v. 2.0. If a copy of the MPL was not distributed with this
  file, You can obtain one at http://mozilla.org/MPL/2.0/.
*/
import { Web3Injector } from '../web3-utils/injector';
import { QRCodeWriter } from '../qrcode';
import platform from 'platform';
export class QurageLink {
    constructor(endpoint, dappName, netVersion, backend, deepLink, rpcClient) {
        this.endpoint = endpoint;
        this.dappName = dappName;
        this.netVersion = netVersion;
        this.backend = backend;
        this.deepLink = deepLink;
        this.rpcClient = rpcClient;
        this.address = null;
    }
    async linkWithDeepLink(shouldOverwriteWeb3 = false) {
        if (platform.os.family.includes('iOS')) {
            window.open('', 'qurage-link');
        }
        const uid = await this.register();
        await this.backend.setDeepLink();
        this.deepLink.link({ dappName: this.dappName, uid });
        return this.watchLink(shouldOverwriteWeb3);
    }
    async linkWithQRCode(canvas, shouldOverwriteWeb3 = false) {
        const uid = await this.register();
        const qrcode = new QRCodeWriter();
        await qrcode.drawQRCodeToCanvas({ uid, dappName: this.dappName }, canvas);
        return this.watchLink(shouldOverwriteWeb3);
    }
    async relink(shouldOverwriteWeb3 = false) {
        await this.backend.init();
        return this.link(() => this.backend.relink(), shouldOverwriteWeb3);
    }
    async unlink() {
        Web3Injector.clear();
        return this.backend.signOut();
    }
    async register() {
        await this.backend.init();
        return this.backend.user.uid;
    }
    async watchLink(shouldOverwriteWeb3) {
        const result = await this.link(() => this.backend.watchLink(), shouldOverwriteWeb3);
        return result;
    }
    async link(linker, shouldOverwriteWeb3) {
        const result = await linker();
        if (result) {
            this.address = result.address;
            this.injectWeb3(shouldOverwriteWeb3);
        }
        return result;
    }
    injectWeb3(shouldOverwrite) {
        if (!this.address) {
            throw new Error('address is not found');
        }
        const injector = new Web3Injector(this.endpoint, {
            address: this.address,
            backend: this.backend,
            deepLink: this.deepLink,
            rpcClient: this.rpcClient,
            netVersion: this.netVersion
        });
        injector.inject(shouldOverwrite);
    }
}
